import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { NEVER, Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { DigitalLogService } from '../services/sections/job/digital-log.service';
import { DigitalLogFormPhoto } from '../models/digital-log/digital-log.model';
import { JobDigitalLogForm } from '@vitralogy/ng-digital-log';

@Injectable({
	providedIn: 'root'
})
export class DigitalLogFormPhotosResolver implements Resolve<Observable<{ form: JobDigitalLogForm, photos: DigitalLogFormPhoto[] }>> {

	constructor(
		private router: Router,
		private digitalLogService: DigitalLogService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		const token = activatedRouteSnapshot.paramMap.get('token');
		const jobDigitalLogFormRequestId = parseInt(activatedRouteSnapshot.paramMap.get('jobDigitalLogFormRequestId'), 10);

		if (isNaN(jobDigitalLogFormRequestId)) {
			this.router.navigate(['/404']);
			GlobalSettingsService.isSecondaryLoaderLoading = false;
			return NEVER;
		}

		return forkJoin([
			this.digitalLogService.getForm(token, jobDigitalLogFormRequestId),
			this.digitalLogService.getFormPhotos(token, jobDigitalLogFormRequestId),
		])
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				map(([form, photos]) => {
					return { form, photos };
				})
			);
	}
}
